import { supabase } from "@/lib/supabase";

export interface ExportTaskLogInput {
  reportKey: string;
  reportName: string;
  category?: string;
  rowCount: number;
  // 带时间窗口的报表（如端点健康快照）额外记下窗口标识，便于在导出历史里直观区分。
  windowLabel?: string;
}

// 把一次「分散在各模块」的导出（如端点健康快照）写进报表中心同一张导出任务表，
// 与报表中心的导出历史共用一份留痕，便于按月统一审计。留痕失败不应影响已完成的导出。
export async function logExportTask(input: ExportTaskLogInput): Promise<void> {
  try {
    await supabase.functions.invoke("admin-license", {
      body: {
        action: "logReportExport",
        reportKey: input.reportKey,
        reportName: input.reportName,
        category: input.category,
        rowCount: input.rowCount,
        windowLabel: input.windowLabel,
      },
    });
  } catch {
    // 留痕失败不影响导出结果
  }
}